import React, { useState } from 'react';
import StocksChannelTabs, { StocksTab } from '../../../StocksLayout/StocksChannelTabs';

const DEFAULT_TABS: StocksTab[] = [
    { id: 'stocks-fbs',     label: 'FBS',      urlTemplate: '/:sellerId/stocks-fbs' },
    { id: 'stocks-fbo',     label: 'FBO',      urlTemplate: '/:sellerId/stocks-fbo' },
    { id: 'stocks-export',  label: 'Отправка', urlTemplate: '/:sellerId/stocks-export' },
    { id: 'stocks-reserve', label: 'Резервы',  urlTemplate: '/:sellerId/stocks-reserve' },
    { id: 'warehouses',     label: 'Склады',   urlTemplate: '/:sellerId/warehouses' },
];

const TAB_ORDER_KEY = 'stocksTabs_order';

const loadTabs = (): StocksTab[] => {
    try {
        const saved: string[] = JSON.parse(localStorage.getItem(TAB_ORDER_KEY) || '[]');
        if (!saved.length) return DEFAULT_TABS;
        return [...DEFAULT_TABS].sort((a, b) => {
            const ai = saved.indexOf(a.id);
            const bi = saved.indexOf(b.id);
            return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
        });
    } catch {
        return DEFAULT_TABS;
    }
};

interface ITabsProps {
    selected: string;
    onAddWarehouse?: () => void;
}

function Tabs({ selected, onAddWarehouse }: ITabsProps) {
    const [tabs, setTabs] = useState<StocksTab[]>(loadTabs);

    const handleReorder = (orderedIds: string[]) => {
        try { localStorage.setItem(TAB_ORDER_KEY, JSON.stringify(orderedIds)); } catch {}
        setTabs([...DEFAULT_TABS].sort((a, b) => {
            const ai = orderedIds.indexOf(a.id);
            const bi = orderedIds.indexOf(b.id);
            return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
        }));
    };

    return (
        <StocksChannelTabs
            tabs={tabs}
            selected={selected}
            onAddWarehouse={onAddWarehouse}
            onReorder={handleReorder}
        />
    );
}

export default Tabs;
